export default __webpack_public_path__ + "static/media/3-min.36681f98.jpg";